<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="charts-section">
	@if (authorizationService.canSee(grants.componentEmissionsEmbodiedEmissionsByApp)) {
		@let embodiedEmissions = embodiedEmissions$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#embodiedEmissionsChart
				chartType="barY"
				[data]="embodiedEmissions?.data?.chart"
				[isLoading]="embodiedEmissions?.isLoading ?? true"
				[hasError]="embodiedEmissions?.hasError || embodiedEmissions?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onEmbodiedEmissionsChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(
							embodiedEmissionsChart.instance,
							'software_embodied_emissions'
						)
					"
				/>
			</div>
		</div>
	}

	<!-- The timeseries and the resources pie are a single widget with one grant. -->
	@if (authorizationService.canSee(grants.componentEmissionsTimeseries)) {
		@let totalCo2Emissions = totalCo2Emissions$ | async;
		@let resourcesEmissions = resourcesEmissions$ | async;

		<div class="resource-emissions">
			<div class="chart-panel">
				<globalictcc-chart
					#totalCo2EmissionsChart
					chartType="line"
					[data]="totalCo2Emissions?.data?.chart"
					[isLoading]="totalCo2Emissions?.isLoading ?? true"
					[hasError]="totalCo2Emissions?.hasError || totalCo2Emissions?.data?.hasError"
					[isLegendVisible]="true"
					(handleChartRefresh)="onTotalCo2EmissionsChartRefresh()"
				/>

				<div class="chart-actions">
					<globalictcc-button
						label="Export chart"
						[textOnly]="true"
						iconName="download"
						(handleClick)="
							onExportChart(
								totalCo2EmissionsChart.instance,
								'software_total_co2_emissions'
							)
						"
					/>
				</div>
			</div>

			<div class="chart-panel">
				<globalictcc-chart
					#resourcesEmissionsChart
					chartType="pie"
					[data]="resourcesEmissions?.data?.chart"
					[isLoading]="resourcesEmissions?.isLoading ?? true"
					[hasError]="resourcesEmissions?.hasError || resourcesEmissions?.data?.hasError"
					[colors]="resourcesEmissionsColors"
					(handleChartRefresh)="onResourcesEmissionsChartRefresh()"
				/>

				<div class="chart-actions">
					<globalictcc-button
						label="Export chart"
						[textOnly]="true"
						iconName="download"
						(handleClick)="
							onExportChart(
								resourcesEmissionsChart.instance,
								'software_resources_emissions'
							)
						"
					/>
				</div>
			</div>
		</div>
	}
</div>
